import React, { Fragment, useState, } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import { useToggle } from 'react-use';
import { mapValues, } from 'lodash';
import { toast } from 'react-toastify';

import ImportButton from './ImportButton';
import { fieldDisplayValue } from '../shared/util';

const { entries } = Object;

export default function PreviewImportButton (props) {
  const { label = 'インポート', fields, previewFields, mapRow = _ => _, modalProps, ...extraProps } = props;
  const [rows, setRows] = useState(null);
  const [isProcessing, toggleProcessing] = useToggle(false);
  const onImport = async (rawRows) => {
    console.log('rawRows:', rawRows);
    console.log('fields:', fields);
    
    const rows = rawRows.map((rawRow) => {
      const mapped = mapValues(fields, field => {
        const key = field.short || field.label;
        const value = rawRow[key] || null;
        return value;
      });
      console.log({ mapped });
      return mapped;
    }).map(mapRow).filter(_ => Object.values(_).some(_ => _));
    
    console.log('final rows:', rows);
    setRows(rows);
  };
  const onFix = async () => {
    toggleProcessing(true);
    try {
      await props.onFix(rows);
      toast.success('インポートしました');
      setRows(null);
    } catch(e) {
      console.error(e);
      toast.error('失敗しました');
    }
    toggleProcessing(false);
  };

  return (
    <Fragment>
      <ImportButton label={label} uncompletes processRows={onImport} {...extraProps} />
      {
        rows != null && (
          <Modal isOpen {...modalProps}>
            <ModalHeader>
              インポート
            </ModalHeader>
            <ModalBody>
              <div className='overflow-auto'>
                <table className="table table-bordered table-sm">
                  <thead className="thead-light">
                    <tr>
                      {
                        entries(previewFields || fields).map(([k, { label }]) => {
                          return (
                            <th key={k} style={{ minWidth: 150, }}>{label}</th>
                          );
                        })
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {
                      rows.map((row, i) => {
                        return (
                          <tr key={i}>
                            {
                              entries(previewFields || fields).map(([k, fieldSetting]) => {
                                const value = row[k];
                                const displayValue = fieldSetting.importPreview?.(row) ?? fieldDisplayValue(value, fieldSetting);
                                return (
                                  <td key={k}>
                                    {displayValue || value || ''}
                                  </td>
                                );
                              })
                            }
                          </tr>
                        );
                      })
                    }
                  </tbody>
                </table>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button className="cancel" color="secondary" onClick={setRows.bind(null, null)}>閉じる</Button>
              <Button className="save" type="submit" color="primary" onClick={onFix} disabled={isProcessing}>インポートする</Button>
            </ModalFooter>
          </Modal>
        )
      }
    </Fragment>
  );
}
